export const ENGAGEMENT_SEGMENT_SEPARATOR = ' · ';
